import React from 'react';
import PropTypes from 'prop-types';
import { EVENT_FAQ_CONST } from './data/constants';
import { eventRulesSelected, eventRulesExplicitlyProhibited } from './data/utils';
import EventRulesContent from './content/EventRulesContent';
import EventRulesExpanded from './content/EventRulesExpanded';

const EventRules = ({ faqData = {}, expanded }) => {
  const { HAS_FLEXIBLE_HOURS } = EVENT_FAQ_CONST;
  const { has_quiet_hours: hasQuietHours } = faqData;
  const hasValidEndTime = hasQuietHours && 'object' === typeof faqData.loud_music_ends_by;
  const hasFlexibleHours = faqData.hasOwnProperty(HAS_FLEXIBLE_HOURS);
  const selectedEventRules = eventRulesSelected(faqData);
  const prohibitedEventRules = eventRulesExplicitlyProhibited(faqData);
  const hasOtherEventRules = faqData.hasOwnProperty('other_event_rules') && '' !== faqData.other_event_rules;
  const hasEventRules = 0 < selectedEventRules.length || 0 < prohibitedEventRules.length || hasOtherEventRules;
  if (expanded) {
    return (
      <>
        <EventRulesExpanded
          faqData={faqData}
          hasValidEndTime={hasValidEndTime}
          hasFlexibleHours={hasFlexibleHours}
        />
      </>
    );
  }
  return (
    <>
      <EventRulesContent
        faqData={faqData}
        hasValidEndTime={hasValidEndTime}
        hasFlexibleHours={hasFlexibleHours}
        hasEventRules={hasEventRules}
        selectedEventRules={selectedEventRules}
        hasOtherEventRules={hasOtherEventRules}
        prohibitedEventRules={prohibitedEventRules}
      />
    </>
  );
};

EventRules.propTypes = {
  faqData: PropTypes.object,
  expanded: PropTypes.bool
};

export default EventRules;
